import ReceiptDetailView from './ReceiptDetail'

const PodDetail = () =>{

    return(
        <ReceiptDetailView type='delivery'/>
    );
};

export default PodDetail;